import React from "react";

//cutome page notification
import AllNotification from "../components/VerticalLayout/AllNotification.js";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import TimesTableReport from "pages/Dashboard/Timestable/times-table-report";
import ManualMark from "pages/Dashboard/Manualmark/manual-mark-list";

import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";


// classes page navigation
import LessonPlan from "pages/Classes/lesson-plan.js";
import Assessment from "pages/Classes/assessment.js";
import Summary from "pages/Classes/summary.js";
import AssessmentDetails from "pages/Classes/assessment-details.js";

import Diagnostics from "pages/Classes/diagnostics";
import DiagnosticSummary from "pages/Classes/diagnosticSummary.js";
import DiagnosticDetails from "pages/Classes/diagnostics-details.js";
import BmdWelcomePage from "pages/Classes/bmd-welcome";
import EngDiagWelcomePage from "pages/Classes/eng-diag-welcome";
import SkillBuilder from "pages/Classes/skillbuilder.js";

import Video from "pages/Classes/video.js";

import Task from "pages/Classes/task.js";

import LinkActivity from "pages/Classes/link-activity.js";
import WorkSheet from "pages/Classes/worksheet.js";
import PdfFormFillPoc from "pages/POC/PdfFormFillPoc.js"; // POC: interactive PDF form fill (throwaway)

import ClassesList from "pages/Classes/classes-list.js";

import GeneralActivity from "../pages/Classes/onetime-activity";



// homework page navigation

import HomeworkList from "pages/Homework/homework-list.js";

import MasteryScores from "pages/Dashboard/Masteryscores/mastery-scores.js";

//Tutor Preview functionality
import PreviewAssessmentDetails from "pages/TutorPreview/preview-assessment-details.js";
import PreviewDiagnosticDetails from "pages/TutorPreview/preview-diagnostics-details.js";
import PreviewVideo from "pages/TutorPreview/preview-video.js";
import PreviewTask from "pages/TutorPreview/preview-task.js";
import PreviewLinkActivity from "pages/TutorPreview/preview-link-activity.js";
import PreviewWorkSheet from "pages/TutorPreview/preview-worksheet.js";
import PreviewOnetime from "pages/TutorPreview/preview-onetime";
import PreviewBmdDetails from "pages/TutorPreview/preview-bmd-details";



//Tutor Manual functionality
import ManualAssessment from "pages/ManualMarking/manual-assessment.js";
import ManualWorksheet from "pages/ManualMarking/manual-worksheet.js";
import ManualLcmsWorksheet from "pages/ManualMarking/manual-lcms-worksheet.js";
import ManualLcmsWorksheetAnswer from "pages/ManualMarking/manual-lcms-worksheet-answer.js";
import { GamePage } from "../pages/Classes/game/game";
import { GameSummaryPage } from "../pages/Classes/game/game-summary-page";

import { GamesHome } from "../pages/Games/Home/games-home";
import { LllPage } from "../pages/Classes/lll/lll-page";
import { WhiteboardPage } from "../pages/Whiteboard/whiteboard";
const VirtualSessionPage = React.lazy( ()=> import("../modules/online-lesson/virtual-session-page")
  .then(module => ({default: module.VirtualSessionPage})));

const userRoutes = [
  { path: "/AllNotification", component: <AllNotification /> },

  { path: "/dashboard", component: <Dashboard /> },
  { path: "/times-table-report", component: <TimesTableReport /> },
  { path: "/manualMark", component: <ManualMark /> },


  //profile
  { path: "/profile", component: <UserProfile /> },

    // classes route
    { path: "/lesson-plan/", component: <Pages404 /> },
    { path: "/lesson-plan/:key", component: <LessonPlan /> },
    { path: "/assessment/", component: <Pages404 /> },
    { path: "/assessment/:key", component: <Assessment /> },
    { path: "/summary/", component: <Pages404 /> },
    { path: "/summary/:key", component: <Summary /> },
    { path: "/assessment-details/", component: <Pages404 /> },
    { path: "/assessment-details/:key", component: <AssessmentDetails /> },
    { path: "/game", component: <GamePage /> },
    { path: "/game-summary/:activity_key", component: <GameSummaryPage /> },
    { path: "/lll", component: <LllPage /> },

    { path: "/diagnostics/", component: <Pages404 /> },
    { path: "/diagnostics/:key", component: <Diagnostics /> },
    { path: "/diagnostic-summary/", component: <Pages404 /> },
    { path: "/diagnostic-summary/:key", component: <DiagnosticSummary /> },
    { path: "/diagnostic-details/", component: <Pages404 /> },
    { path: "/diagnostic-details/:key", component: <DiagnosticDetails /> },

    { path: "/bmd/", component: <Pages404 /> },
    { path: "/bmd/:key", component: <BmdWelcomePage /> },

    // The key is the pk_lesson_activity_key: the lesson plan knows the activity,
    // and the session behind it is resolved server-side.
    { path: "/eng-diag/", component: <Pages404 /> },
    { path: "/eng-diag/:key", component: <EngDiagWelcomePage /> },

    // The key is the pk_lesson_activity_key, not the skillbuilder id: one
    // Skill Builder can be assigned to several students, and it is the
    // ASSIGNMENT that is being opened.
    { path: "/skillbuilder/", component: <Pages404 /> },
    { path: "/skillbuilder/:key", component: <SkillBuilder /> },
    
    { path: "/video/", component: <Pages404 /> },
    { path: "/video/:key", component: <Video /> },

    { path: "/task/", component: <Pages404 /> },
    { path: "/task/:key", component: <Task /> },

    { path: "/link/", component: <Pages404 /> },
    { path: "/link/:key", component: <LinkActivity /> },

    { path: "/worksheet/", component: <Pages404 /> },
    { path: "/worksheet/:key", component: <WorkSheet /> },

    { path: "/onetime-activity/", component: <Pages404 /> },
    { path: "/general-activity/:key", component: <GeneralActivity /> },


  { path: "/classes-list", component: <ClassesList /> },
  //{ path: "/lesson-plan/", component: <ClassesDetail /> },

    { path: "/games-home", component: <GamesHome /> },
    { path: "/whiteboard", component: <WhiteboardPage /> },

    // homework route

  { path: "/homework-list", component: <HomeworkList /> },
  
  { path: "/", component: <Dashboard /> },

  { path: "/mastery-scores", component: <MasteryScores /> },

  { path: "/video-session/:sessionKey", component: <VirtualSessionPage />, layout: {plainLayout: true} },
];


const authRoutes = [

  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // POC: interactive PDF form fill — throwaway, public (no login), remove before merge
  { path: "/pdf-form-poc", component: <PdfFormFillPoc /> },

  //Tutor app preview screen
    { path: "/preview-assessment-details/", component: <Pages404 /> },
    { path: "/preview-assessment-details/:key", component: <PreviewAssessmentDetails /> },
   
    { path: "/preview-diagnostic-details/", component: <Pages404 /> },
    { path: "/preview-diagnostic-details/:key", component: <PreviewDiagnosticDetails /> },

    // Assigned BMD activity (activity_type 13), base or prerequisite test.
    { path: "/preview-bmd/", component: <Pages404 /> },
    { path: "/preview-bmd/:key", component: <PreviewBmdDetails /> },
    
    { path: "/preview-video/", component: <Pages404 /> },
    { path: "/preview-video/:key", component: <PreviewVideo /> },

    { path: "/preview-task/", component: <Pages404 /> },
    { path: "/preview-task/:key", component: <PreviewTask /> },

    { path: "/preview-link/", component: <Pages404 /> },
    { path: "/preview-link/:key", component: <PreviewLinkActivity /> },

    { path: "/preview-worksheet/", component: <Pages404 /> },
    { path: "/preview-worksheet/:key", component: <PreviewWorkSheet /> },

    //manual mark
    { path: "/manual-assessment/", component: <Pages404 /> },
    { path: "/manual-assessment/:key", component: <ManualAssessment /> },

    { path: "/manual-worksheet/", component: <Pages404 /> },
    { path: "/manual-worksheet/:key", component: <ManualWorksheet /> },

    { path: "/manual-lcms-worksheet/", component: <Pages404 /> },
    { path: "/manual-lcms-worksheet/:key", component: <ManualLcmsWorksheet /> },
    
    { path: "/manual-lcms-worksheet-answer/", component: <Pages404 /> },
    { path: "/manual-lcms-worksheet-answer/:key", component: <ManualLcmsWorksheetAnswer /> },

    { path: "/preview-onetime/", component: <Pages404 /> },
    { path: "/preview-onetime/:key", component: <PreviewOnetime /> },

];

export { userRoutes, authRoutes };
